import axios from 'axios';

import apiClient from '@/lib/apiClient';
import { ApiResponse } from '@/types';

// The T&C page is reached by a lead with no account, so these calls must NOT go
// through apiClient (which attaches the RM's auth token and runs refresh-on-401
// interceptors). A bare client against the same API base is correct here.
const publicClient = axios.create({ baseURL: import.meta.env.VITE_API_BASE_URL });

export type TcType = 'ALL' | 'MFTOOLS' | 'API';

export interface PublicTcView {
  type: TcType;
  version: string;
  title: string;
  html: string;
  status: 'accepted' | 'pending';
  acceptedAt: string | null;
}

export interface TcAcceptResult {
  status: 'accepted';
  acceptedAt: string;
}

export const getPublicTc = async (token: string): Promise<PublicTcView> => {
  const { data } = await publicClient.get<ApiResponse<PublicTcView>>(`/public/tc/${token}`);
  if (!data.data) throw new Error('Terms & Conditions not found');
  return data.data;
};

export const acceptPublicTc = async (token: string): Promise<TcAcceptResult> => {
  const { data } = await publicClient.post<ApiResponse<TcAcceptResult>>(
    `/public/tc/${token}/accept`,
  );
  if (!data.data) throw new Error('Could not record acceptance');
  return data.data;
};

export interface TcDocument {
  type: TcType;
  version: string;
  title: string;
  html: string;
}

// Authenticated: the three T&C documents for the admin/RM preview page.
export const getTcDocuments = async (): Promise<TcDocument[]> => {
  const { data } = await apiClient.get<ApiResponse<TcDocument[]>>('/tc/documents');
  return data.data ?? [];
};
